import * as React from 'react';
// import  request  from '@/server/request';
// import config from '@/server/config';
import './index.scss'

interface initProps {
	visiblity ?: boolean,
	position ?: string,
}

class Dialog extends React.Component <initProps, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			
		}
	}

	render() {
		return (
			<div>
				{
					this.props.visiblity ?
					<div className={`dialog ${this.props.position ? this.props.position : ''}`}>
						<div className="mask"></div>
						<div className="dialog-content">
							{this.props.children}
						</div>
					</div> : ''
				}
			</div>
		)
	}
}



export default Dialog